export default "__VITE_ASSET__kDqEIMx$__"